import Accordion from '@components/Accordion';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import useStampNote from './hooks/useStampNote';

function StampNote() {
    const { t } = useTranslation('stamp');
    const note = useStampNote();
    if (note) {
        return (
            <Accordion title={t('notice.title')} >
                <Text color={colors.gray6} as='div'
                    css={noteCss}
                    dangerouslySetInnerHTML={{ __html: note || '' }}
                />
            </Accordion>
        );
    }
    return null;
}

const noteCss = css`
    white-space: pre-wrap;
    img {
        max-width: 100%;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;
    }

    ul {
        list-style-type: disc;
        list-style-position: outside;
        display: block;
        padding-left: 16px;
    }

    ol {
        list-style-type: decimal;
        list-style-position: outside;
        padding-left: 20px;
    }

    li {
        display: list-item;
    }

    h1, h2, h3 {
        font-weight: 400;
    }

    h1 {
        font-size: 24px;
    }

    h2 {
        font-size: 20px;
    }

    h3 {
        font-size: 16px;
    }

    p {
        font-size: 14px;
        min-height: 20px;
    }
`;

export default StampNote;
